import { Component, input, InputSignal } from '@angular/core';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    standalone: true,
    host: {
        class: 'overflow-hidden bg-[var(--table-row-bg,var(--base-2))] group-hover:bg-[var(--table-row-bg-hover,var(--base-4))]',
        '[style.min-width]': 'minWidth()',
        '[class.sticky]': 'sticky()',
        '[class.left-0]': 'sticky()',
        '[class.z-10]': 'sticky()'
    }
})
export class TableCellComponent {
    public width: InputSignal<string> = input('1fr');
    public minWidth: InputSignal<string> = input('100px');
    public sticky: InputSignal<boolean> = input(false);
}
